import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-final-form";
import { DebounceInput } from "react-debounce-input";
// import UiRangeSlider from "../../../_uiComponents/form/UiRangeSlider";
import {
    UiFilterWr,
    UiFilterTitle,
    UiFilterSeeMore,
    UiFilterContainer,
} from "../../../../_uiComponents/common/UiFilterComponents";
import UiFiterInput from "../../../../_uiComponents/form/UiFilterInput";
import { UiCheckboxInput } from "../../../../_uiComponents/form/UiInput";
import {
    shopBrowseProductsCategoryRequest,
    shopBrowseProductsPopularFilterRequest,
} from "../../../../../_redux/_actions";
import { Accordion, Card } from "react-bootstrap";
import { useSpring, animated } from "@react-spring/web";

export default function ShopFilter(props, { show }) {
    const actionDispatch = useDispatch();

    const { category, popularFilters } = useSelector((state) => {
        return {
            category: state.shop.category,
            popularFilters: state.shop.popularFilters,
        };
    });    

    const [isTypesExpanded, setIsTypesExpanded] = useState(false);

    const [isFiltersExpanded, setIsFiltersExpanded] = useState(false);

    const handleTypesExpanded = () => {
        setIsTypesExpanded(!isTypesExpanded);
    };

    const handleFiltersExpanded = () => {
        setIsFiltersExpanded(!isFiltersExpanded);
    };

    useEffect(() => {
        actionDispatch(shopBrowseProductsCategoryRequest());
        actionDispatch(shopBrowseProductsPopularFilterRequest());
    }, []);

    const properties = useSpring({
        left: props.show ? window.innerWidth - 365 : window.innerWidth,
        position: "fixed",
        top: 138,
        overflowY: "scroll",
        backgroundColor: "#ffff",
        zIndex: "100",
        maxHeight: 700,
        width: "100%",
        padding: "1rem",
        paddingRight: "2.3rem",
    });

    return (
        <>
            <div
                className={
                    props.show ? "sb-filter-section-mob" : "sb-filter-section"
                }
            >
                <animated.div style={properties}>
                    <UiFilterWr>
                        <UiFilterTitle title="Filter" />
                        <DebounceInput
                            placeholder={"Search Rewards"}
                            minLength={2}
                            debounceTimeout={500}
                            onChange={(event) => {
                                props.setSearchString(event.target.value);
                            }}
                            element={UiFiterInput}
                        />
                    </UiFilterWr>
                    <UiFilterWr>
                        <UiFilterTitle title="Popular Filters" />
                        <Form
                            onSubmit={() => {}}
                            render={({ handleSubmit, hasValidationErrors }) => (
                                <form>
                                    {popularFilters.slice(0, 5).map((popularFilter) => (
                                        <UiCheckboxInput
                                            type="checkbox"
                                            key={popularFilter.id}
                                            onClick={() => {
                                                props.selectFilters(
                                                    popularFilter.id,
                                                );
                                            }}
                                            name={popularFilter.name}
                                            label={popularFilter.name}
                                        />
                                    ))}
                                    {(popularFilters && popularFilters.length > 5) &&
                                        <Accordion className="custom-accordion">
                                            <Card>
                                                {!isFiltersExpanded && (
                                                    <Card.Header onClick={handleFiltersExpanded}>
                                                        <UiFilterSeeMore />
                                                    </Card.Header>
                                                )}
                                                <Accordion.Collapse in={isFiltersExpanded}>
                                                    <Card.Body>
                                                        {popularFilters.slice(5).map((popularFilter) => (
                                                            <UiCheckboxInput
                                                                type="checkbox"
                                                                key={popularFilter.id}
                                                                onClick={() => {
                                                                    props.selectFilters(
                                                                        popularFilter.id,
                                                                    );
                                                                }}
                                                                name={popularFilter.name}
                                                                label={popularFilter.name}
                                                            />
                                                        ))}
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                    }
                                </form>
                            )}
                        />
                    </UiFilterWr>
                    <hr />
                    <UiFilterWr>
                        <UiFilterTitle title="Voucher Type" />
                        <Form
                            onSubmit={() => {}}
                            render={({ handleSubmit, hasValidationErrors }) => (
                                <form>     
                                    {category.slice(0, 5).map((category) => (
                                        <UiCheckboxInput
                                            key={category.id}
                                            type="checkbox"
                                            onClick={() => {
                                                props.selectCategories(category.id);
                                            }}
                                            name={category.name}
                                            label={category.name}
                                        />
                                    ))}
                                    {(category && category.length > 5) &&
                                        <Accordion className="custom-accordion">
                                            <Card>
                                                {!isTypesExpanded && (
                                                    <Card.Header onClick={handleTypesExpanded}>
                                                        <UiFilterSeeMore />
                                                    </Card.Header>
                                                )}
                                                <Accordion.Collapse in={isTypesExpanded}>
                                                    <Card.Body>
                                                        {category.slice(5).map((category) => (
                                                            <UiCheckboxInput
                                                                key={category.id}
                                                                type="checkbox"
                                                                onClick={() => {
                                                                    props.selectCategories(category.id);
                                                                }}
                                                                name={category.name}
                                                                label={category.name}
                                                            />
                                                        ))}
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                    }
                                </form>
                            )}
                        />

                        {/* <UiFilterSeeMore /> */}
                    </UiFilterWr>
                    <hr />
                    <UiFilterWr>
                        <UiFilterTitle title="User Rating" />

                        <Form
                            onSubmit={() => {}}
                            render={({ handleSubmit, hasValidationErrors }) => (
                                <form>
                                    <UiCheckboxInput
                                        onClick={() =>
                                            props.selectUserRatings(5)
                                        }
                                        name="5Star"
                                        label="5 Star"
                                    />
                                    <UiCheckboxInput
                                        onClick={() =>
                                            props.selectUserRatings(4)
                                        }
                                        name="4Star"
                                        label="4 Star"
                                    />
                                    <UiCheckboxInput
                                        onClick={() =>
                                            props.selectUserRatings(3)
                                        }
                                        name="3Star"
                                        label="3 Star"
                                    />
                                </form>
                            )}
                        />
                    </UiFilterWr>
                </animated.div>
            </div>
        </>
    );
}
